<pathPantalla></pathPantalla>

<!-- Filtros -->
<div class="row">
    <div class="col-lg-12" style="padding: 0px">
        <section class="widget">
            <!-- título -->
            <header>
                <h3> {{sistemaService.NombrePantallaActual}} </h3>
            </header>
            <div class="separador"></div>
            <filtros (filtroAplicado)="SetDatos($event)" [urlApi]="uriApi" #filtrosComponent></filtros>
        </section>
    </div>
</div>

<div class="divisor8"></div>

<div class="row">
    <div class="col-lg-12" style="padding: 0px">
        <section class="widget">
            <!-- tabla -->
            <div>

                <!-- Agregar  -->
                <div>
                    <button class="btn boton botonXS" (click)="Modal()" *ngIf="sistemaService.permisos.agregar">
                        <span class="fa fa-plus"></span>
                        <span> {{'Agregar'}}</span>
                    </button>
                </div>

                <div class="divisor16"></div>

                <!-- datos -->
                <dx-data-grid
                    (onOptionChanged)="sistemaService.CambiarPaginacionTabla($event)"
                    id="tabla"
                    [columnAutoWidth]="true"
                    [dataSource]="dataTable"
                    [showColumnHeaders]="true"
                    [wordWrapEnabled]="true"
                    >
                    <dxo-export [enabled]="true" [fileName]="sistemaService.NombrePantallaActual" *ngIf="sistemaService.permisos.exportar"></dxo-export>

                    <dxo-search-panel
                        [visible]="true"
                        [width]="240"
                        placeholder="{{'Buscar' | translate}}">
                    </dxo-search-panel>

                    <dxo-paging [pageSize]="sistemaService.tablaPaginacion"></dxo-paging>
                    <!--<dxo-scrolling mode="virtual" [useNative]="false" [showScrollbar]="'always'"></dxo-scrolling>-->

                    <dxo-pager
                        [visible]="true"
                        [allowedPageSizes]="sistemaService.tablaPaginacionPaginaSize"
                        [displayMode]="sistemaService.tablaPaginacionModo"
                        [showPageSizeSelector]="sistemaService.tablaPaginacionSelector"
                        [showInfo]="sistemaService.tablaPaginacionInfo"
                        [showNavigationButtons]="sistemaService.tablaPaginacionNavegacion">
                    </dxo-pager>

                    <dxi-column
                        [allowExporting]="false"
                        caption="Acciones"
                        cellTemplate="cellAcciones"
                        alignment="center">

                    </dxi-column>
                    <dxi-column
                        dataField="nombre"
                        caption="Descripción">
                    </dxi-column>
                    <dxi-column
                        dataField="asociarnivel"
                        caption="Asociar a nivel"
                        cellTemplate="cellAsociar"
                        [calculateCellValue]="setAsociarNivel"
                        alignment="center">
                    </dxi-column>
                    <dxi-column
                        dataField="activo"
                        caption="Activo"
                        cellTemplate="cellActivo"
                        [calculateCellValue]="sistemaService.GetValorActivo"
                        alignment="center">
                    </dxi-column>



                    <!-- Asociar -->
                    <div *dxTemplate="let cell of 'cellAsociar'" class="iconoActivo">
                        <span *ngIf="cell.data.asociarnivel" class="fa fa-check-square-o"></span>
                        <span *ngIf="!cell.data.asociarnivel" class="fa fa-square-o"></span>
                    </div>
                    <!-- Activo -->
                    <div *dxTemplate="let cell of 'cellActivo'" class="iconoActivo">
                        <span *ngIf="cell.data.activo" class="fa fa-check-square-o"></span>
                        <span *ngIf="!cell.data.activo" class="fa fa-square-o"></span>
                    </div>
                    <!-- Acciones -->
                    <div *dxTemplate="let cell of 'cellAcciones'">
                        <a matTooltip="Editar" class="tablaBoton edit" (click)="Editar(cell.data)" *ngIf="sistemaService.permisos.editar">
                            <i class="fa fa-pencil fa-lg" aria-hidden="true"></i>
                        </a>
                        <a matTooltip="Eliminar" class="tablaBoton separado delete" (click)="Eliminar(cell.data)" *ngIf="sistemaService.permisos.eliminar">
                            <i class="fa fa-trash fa-lg" aria-hidden="true"></i>
                        </a>
                    </div>

                </dx-data-grid>

            </div>
        </section>
    </div>
</div>

<ng-container *ngIf="abierto">
    <div class="backdrop"></div>
    <div class="modalPanelAdmin small animated {{animacion}}">

        <div class="contenido">
            <!-- Título -->
            <div class="encabezadoModal">
                <div class="modalTituloSimple">
                    {{(entidad.tipodepartamentoid == 0 ? 'Agregar' : 'Editar')}}
                </div>
            </div>
            <div class="modalContenido">
                <!-- datos -->
                <div>
                    <div class="divisor8"></div>
                    <div>
                        <!-- Datos generales -->
                        <div class="row">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                                <inputCustom [titulo]="'Descripción'" [(ngModel)]="entidad.nombre" [errorActivo]="errorActivo"></inputCustom>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                                <checkBoxCustom [titulo]="'Asociar a nivel'" [alineacion]="1"  [(ngModel)]="entidad.asociarnivel"></checkBoxCustom>
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                                <checkBoxCustom [titulo]="'Activo'" [alineacion]="1" [(ngModel)]="entidad.activo"></checkBoxCustom>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <!-- footer -->
            <div class="modalFooter">
                <div class="contenidoFooter botonesIzq">
                    <!-- editar -->
                    <div class="botonDerecha">
                        <button class="boton botonSM filledBlanco" (click)="CerrarModal()">
                            {{'Cancelar' | translate}}
                        </button>
                        <div class="divisorH16"></div>
                        <button class="boton botonSM filled" (click)="Guardar()">
                            {{'Guardar' | translate}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
